module.exports = __webpack_public_path__ + "static/media/estosomos.aea8ce12.png";